/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UploadBatchItem } from './UploadBatchItem';
import {
    UploadBatchItemFromJSON,
    UploadBatchItemFromJSONTyped,
    UploadBatchItemToJSON,
    UploadBatchItemToJSONTyped,
} from './UploadBatchItem';
import type { UploadBatchSummary } from './UploadBatchSummary';
import {
    UploadBatchSummaryFromJSON,
    UploadBatchSummaryFromJSONTyped,
    UploadBatchSummaryToJSON,
    UploadBatchSummaryToJSONTyped,
} from './UploadBatchSummary';

/**
 * 
 * @export
 * @interface UploadBatchGetResponse
 */
export interface UploadBatchGetResponse {
    /**
     * 
     */
    batch: UploadBatchSummary;
    /**
     * 
     */
    items: Array<UploadBatchItem>;
}

/**
 * Check if a given object implements the UploadBatchGetResponse interface.
 */
export function instanceOfUploadBatchGetResponse(value: object): value is UploadBatchGetResponse {
    if (!('batch' in value) || value['batch'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function UploadBatchGetResponseFromJSON(json: any): UploadBatchGetResponse {
    return UploadBatchGetResponseFromJSONTyped(json, false);
}

export function UploadBatchGetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadBatchGetResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'batch': UploadBatchSummaryFromJSON(json['batch']),
        'items': ((json['items'] as Array<any>).map(UploadBatchItemFromJSON)),
    };
}

export function UploadBatchGetResponseToJSON(json: any): UploadBatchGetResponse {
    return UploadBatchGetResponseToJSONTyped(json, false);
}

export function UploadBatchGetResponseToJSONTyped(value?: UploadBatchGetResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'batch': UploadBatchSummaryToJSON(value['batch']),
        'items': ((value['items'] as Array<any>).map(UploadBatchItemToJSON)),
    };
}

